<template lang="html">
  <form class="join" @submit.prevent="handleSubmit">
    <div class="form-content">
      <div class="inputs-with-hidden-labels">
        <label class="form-row">
          <div class="label-text">Email address</div>
          <input
            v-model="email"
            v-focus="!email"
            name="email"
            type="email"
            autocomplete="email"
            placeholder="Email address"
            required
          />
        </label>

        <label class="form-row">
          <div class="label-text">Password</div>
          <input
            v-model="password"
            v-focus="email"
            name="password"
            type="password"
            autocomplete="new-password"
            placeholder="Password"
            required
          />
        </label>

        <LoadingButton
          class="form-row"
          button-text="Sign Up"
          :is-loading="isLoading"
        />

        <ErrorList :errors="serverErrors" />

        <p class="form-row account-message">
          Have an account?
          <router-link :to="{ name: 'login', query: $route.query }"
            >Log in</router-link
          >
        </p>
      </div>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex';
import { snakeCase } from 'lodash';
import authenticationMixin from '@/mixins/authentication';
import deepMapKeys from '@/utils/deep-map-keys';
import { metaRobots } from '@/utils/meta';
import LoadingButton from '@/components/LoadingButton';

export default {
  name: 'Join',

  components: {
    LoadingButton,
  },

  mixins: [authenticationMixin],

  metaInfo() {
    return {
      meta: [...metaRobots()],
    };
  },

  computed: {
    ...mapGetters(['settings']),
  },

  beforeMount() {
    if (this.$route.query.email) {
      this.email = this.$route.query.email;
    }
  },

  methods: {
    async handleSubmit() {
      const signupResponse = await this.handleFormSignup({
        redirect: false,
        data: {
          settings: deepMapKeys(this.settings, (value, key) => snakeCase(key)),
        },
      });

      if (signupResponse.status >= 400) {
        return;
      }

      this.$toasted.show(`Confirmation email sent to ${this.email}`, {
        type: 'success',
      });

      await this.handleFormLogin();
    },
  },
};
</script>

<style scoped lang="scss">
.base-mail-to-link {
  margin-left: 0.3em;
}

.username-guidelines [data-icon] {
  margin-left: 0.25em;
  font-size: 0.9em;
}

.sub-text {
  color: map-get($colors, 'grey');
  font-size: 0.9em;
}
</style>
